import apiClient from './apiClient';

export interface BetaAllowlistEntry {
  email: string;
  invited_at: string;
  signed_up_at: string | null;
}

export interface AddEmailResponse {
  message: string;
  entry?: BetaAllowlistEntry;
  entries?: BetaAllowlistEntry[];
}

export interface GetAllowlistResponse {
  entries: BetaAllowlistEntry[];
}

export const getBetaAllowlist = async (): Promise<BetaAllowlistEntry[]> => {
  const response = await apiClient.get('admin/beta-allowlist');
  return (response.data as GetAllowlistResponse).entries;
};

export const addToBetaAllowlist = async (
  emailOrEmails: string | string[]
): Promise<AddEmailResponse> => {
  const payload = Array.isArray(emailOrEmails)
    ? { emails: emailOrEmails }
    : { email: emailOrEmails };
  const response = await apiClient.post('admin/beta-allowlist', payload);
  return response.data;
};

export const removeFromBetaAllowlist = async (email: string): Promise<{ message: string }> => {
  const encodedEmail = encodeURIComponent(email);
  const response = await apiClient.delete(`admin/beta-allowlist/${encodedEmail}`);
  return response.data;
};
